
import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function consoleMediaList(
    console_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/console/${console_id}/media/list${queryString}`
    );
}

export async function consoleMediaGet(
    item_id: string
) {
    return await clientAxios.get(
        `admin/console/media/${item_id}/show`
    );
}

export async function consoleMediaCreate(
    console_id: string,
    payload: Partial<any>
) {
    return await clientAxios.post(
        `admin/console/${console_id}/media/create`,
        payload
    );
}

export async function consoleMediaPatch(
    item_id: string,
    payload: Partial<any>
) {
    return await clientAxios.patch(
        `admin/console/media/${item_id}/patch`,
        { payload }
    );
}

export async function consoleMediaDel(
    item_id: string,
) {
    return await clientAxios.del(
        `admin/console/media/${item_id}/delete`,
    );
}
